import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ProcessStep } from '../../../pages/ng-for-business/ng-for-business.models';

@Component({
  selector: 'app-process-steps',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './process-steps.component.html',
  styleUrls: ['./process-steps.component.scss'],
})
export class ProcessStepsComponent {
  @Input({ required: true }) title!: string;
  @Input({ required: true }) steps!: ProcessStep[];

  trackByStep = (_: number, step: ProcessStep) => step.title;
}
